import { Component, HostListener, OnInit } from '@angular/core';
import { CtrlBaseComponent } from '../ctrl-base.component';
import { breakpoints } from '../../environments/environment.breakpoints';


@Component({
  selector: 'ct-divider',
  templateUrl: './ct-divider.component.html',
  styleUrls: ['./ct-divider.component.css']
})
export class CtDividerComponent extends CtrlBaseComponent implements OnInit {

  public isMediumSize : boolean = false;
  public isSmallSize : boolean = false;
  public isExtraSmall : boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.manageWindowResizing(window.innerWidth);
  }

  private manageWindowResizing(width: number) {
    this.isMediumSize = width >= breakpoints.M;
    this.isSmallSize = width < breakpoints.L && width >= breakpoints.M;
    this.isExtraSmall = width >= breakpoints.S && width < breakpoints.M;
  }

  constructor() { 
    super();
  }

  getClass() {
    const result = super.getEffectiveClass(this.isMediumSize, this.isSmallSize, this.isExtraSmall);
    return result;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.onResize();
  }

}
